/* ========================================
   CREMED テーマ グローバルスクリプト
   （元の静的サイト index.html の挙動を移植）
   ======================================== */
(function () {
  'use strict';

  // ---------- intro veil ----------
  window.addEventListener('load', function () {
    setTimeout(function () { document.body.classList.add('is-loaded'); }, 450);
  });

  // ---------- image probe: プレースホルダを実画像に差し替え（ズームレイヤー） ----------
  document.querySelectorAll('.media[data-img]').forEach(function (el) {
    var src = el.dataset.img;
    if (!src) return;
    var layer = document.createElement('div');
    layer.className = 'media-img';
    el.appendChild(layer);
    var img = new Image();
    img.onload = function () {
      layer.style.backgroundImage = 'url("' + src + '")';
      el.classList.add('is-img');
    };
    img.src = src;
  });

  var header = document.querySelector('.header');
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  // ---------- スクロールリビール（IntersectionObserver） ----------
  if (!reduce) {
    var ioZoom = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('media-on'); ioZoom.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.media[data-img]').forEach(function (el) { ioZoom.observe(el); });

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-inview'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.reveal,[data-stagger]').forEach(function (el) { io.observe(el); });

    var ioClip = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-inview'); ioClip.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.reveal-clip').forEach(function (el) { ioClip.observe(el); });
  } else {
    document.querySelectorAll('.reveal,[data-stagger],.reveal-clip').forEach(function (el) {
      el.classList.add('is-inview');
    });
    document.querySelectorAll('.media[data-img]').forEach(function (el) { el.classList.add('media-on'); });
  }

  // ---------- header scrolled ----------
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // ---------- parallax（PCのみ・[data-parallax]要素） ----------
  var pxEls = [].slice.call(document.querySelectorAll('[data-parallax]')).map(function (el) {
    return { el: el, sp: parseFloat(el.dataset.parallax), cur: 0 };
  });
  if (pxEls.length && !reduce) {
    (function parallax() {
      var off = innerWidth <= 980;
      pxEls.forEach(function (o) {
        if (off) { if (o.cur !== 0) { o.cur = 0; o.el.style.transform = ''; } return; }
        if (o.el.classList.contains('hero-visual')) return; // ヒーローは登場アニメ優先
        var r = o.el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var center = (r.top + r.height / 2 - innerHeight / 2);
        o.cur += (center * o.sp - o.cur) * 0.12;
        o.el.style.transform = 'translate3d(0,' + o.cur.toFixed(2) + 'px,0)';
      });
      requestAnimationFrame(parallax);
    })();
  }

  // ---------- mobile menu ----------
  var menuBtn = document.querySelector('.menu-btn');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      var open = document.body.classList.toggle('menu-open');
      menuBtn.setAttribute('aria-expanded', open);
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('menu-open');
        menuBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ---------- custom cursor ----------
  var dot = document.querySelector('.cursor-dot');
  var ring = document.querySelector('.cursor-ring');
  if (dot && ring && matchMedia('(pointer:fine)').matches) {
    var mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my;
    addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    });
    (function ringLoop() {
      rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(ringLoop);
    })();
    document.querySelectorAll('a,button,[data-hover]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { document.body.classList.add('cursor-hover'); });
      el.addEventListener('mouseleave', function () { document.body.classList.remove('cursor-hover'); });
    });
  }

  // ---------- 商品ページ: サムネイルでメイン画像を差し替え ----------
  var mainImg = document.querySelector('.product__media > img');
  var thumbs = document.querySelectorAll('.product__thumbnail');
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.src.replace('width=200', 'width=1200');
        mainImg.srcset = '';
      });
    });
  }
})();
